import type { RecordOf } from 'immutable';

import { resourceStoreTypes } from '../core';

export const ACHIEVEMENTS_REDUCER_KEY = 'achievementsStore';

export type AchievementContent = {
  description?: string;
};

export type AchievementProps = {
  id?: string | null;
  clientId?: string | null;
  isDeleted?: boolean | null;
  sortId?: string | null;
  state?: string | null;
  knownAchievementId?: string | null;
  name?: string | null;
  content?: AchievementContent | null;
};

export type Achievement = RecordOf<AchievementProps>;

export type AchievementsStore = resourceStoreTypes.QcsSyncResourceStore<AchievementProps>;
export const mkAchievementsStore = resourceStoreTypes.createTypedQcsSyncResourceStoreFactory<AchievementProps>();

export type AchievementEventPayload = {
  source: string;
  eventType: string;
};

export type AchievementEventProps = {
  id?: string | null;
  clientId?: string | null;
  isDeleted?: boolean | null;
  source?: string | null;
  eventType?: string | null;
  eventId?: string | null;
  eventOn?: string | null;
};

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [ACHIEVEMENTS_REDUCER_KEY]: AchievementsStore;
  }
}
